import React, { Component } from 'react';


export default class Resume extends Component {
    

    render(){
        return (
        <div>
          <h1> Resume </h1>
            <div>Please contact me via linkedin for resume</div>
        </div>)
    }

}